import { type RouteConfig } from 'vue-router'

export const ValidationMailSentRouter: RouteConfig[] = [
  {
    path: '/ValidationMailSent',
    component: async () => import('./ValidationMailSent.vue'),
  },
]
